export const MIN_RELATION_BREAK_VALUE = 0;
export const MAX_RELATION_BREAK_VALUE = 32767;